import React from 'react';
import '../styles/DefaultUserImage.css';
import { CameraSmile02Icon } from 'hugeicons-react';
import { colour } from '../styles/GlobalStyles';

function DefaultUserImage(props) {
    const clickFunc = props.clickFunc;
    const size = props.size;
    const image = props.image;
    return (
        <div
            className={"default-user-image-container " + (size === "small" ? "default-user-image-small " : "default-user-image-large ") + (clickFunc === null ? "" : "cursor-pointer")}
            onClick={() => clickFunc === null ? null : clickFunc()}
            style={image ? { backgroundImage: `url(${image})` } : {}}
        >
            {
                image === null &&
                <CameraSmile02Icon
                    color={colour.gray03}
                    size={size === "small" ? 20 : 24}
                />
            }
        </div>
    )
};

export default DefaultUserImage;